import { render, staticRenderFns } from "./ModalConteoMilitantes.vue?vue&type=template&id=081b706d"
import script from "./ModalConteoMilitantes.vue?vue&type=script&lang=js"
export * from "./ModalConteoMilitantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports